import { useState, useEffect } from "react";
import {
  Button,
  Card,
  Table,
  Container,
  Row,
  Col,
  Input,
  CardFooter,
} from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import { reportmanageService } from "../../../services/reportmanageService";
import { taskmanageService } from "../../../services/taskmanageService";
import "../../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import Paginationcomponent from "components/Paginationcomponent.js";
import { toast } from "react-toastify";

const user_info = JSON.parse(localStorage.getItem('user-info'));
const allowedStatusIds = [1, 3, 7];

const InternalPhaseErrorReport = (props) => {
  const [reportdata, setReportdata] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [total_page, setTotalData] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const rowsPerPageOptions = [5, 10, 25, 50, 100];
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [statusList, setStatusList] = useState([]);

  useEffect(() => {
    get_report_data(1);
    taskmanageService.getstatus('internalrej').then((response) => {
      if (response && response.data && response.data.status) {
        setStatusList(response.data.status.filter(s => allowedStatusIds.includes(s.id)));
      }
    });
  }, []);

  function get_report_data(page) {
    reportmanageService.getInternalPhaseErrorReport(startDate, endDate, page, rowsPerPage).then((response) => {
      if (response && response.data) {
        setReportdata(response.data.data.data);
        setCurrentPage(response.data.data.current_page);
        setTotalData(response.data.data.total);
      }
    });
  }

  function downloadReport() {
    reportmanageService.exportInternalPhaseErrorReport(startDate, endDate);
  }

  function applyFilter() {
    get_report_data(1);
  }

  function resetFilter() {
    setStartDate('');
    setEndDate('');
    setTimeout(() => {
      reportmanageService.getInternalPhaseErrorReport('', '', 1, rowsPerPage).then((response) => {
        if (response && response.data) {
          setReportdata(response.data.data.data);
          setCurrentPage(response.data.data.current_page);
          setTotalData(response.data.data.total);
        }
      });
    }, 100);
  }

  const handlePageClick = (page) => {
    setCurrentPage(page);
    get_report_data(page);
  };

  const handlePreviousClick = () => {
    if (currentPage > 1) {
      handlePageClick(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage < Math.ceil(total_page / rowsPerPage)) {
      handlePageClick(currentPage + 1);
    }
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    get_report_data(1);
  };

  function handleStatusChange(id, status) {
    reportmanageService.updateInternalPhaseErrorStatus(id, status).then((response) => {
      if (response && response.status == 200) {
        toast.success(response.data.message);
        get_report_data(currentPage);
      } else {
        toast.error('Something went wrong');
      }
    });
  }

  function formatDate(dateStr) {
    if (!dateStr) return '';
    let d = new Date(dateStr);
    let day = String(d.getDate()).padStart(2, '0');
    let month = String(d.getMonth() + 1).padStart(2, '0');
    let year = d.getFullYear();
    return day + '-' + month + '-' + year;
  }

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <div className="row">
          <div className="col-xl-12">
            <div className="col-md-12 col-12"></div>
            <Row>
              <Col xl="3">
                <label>Start Date</label>
                <Input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </Col>
              <Col xl="3">
                <label>End Date</label>
                <Input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </Col>
              <Col xl="2" style={{ paddingTop: '32px' }}>
                <Button color="primary" size="sm" onClick={applyFilter}>
                  Filter
                </Button>
                <Button color="secondary" size="sm" onClick={resetFilter}>
                  Reset
                </Button>
              </Col>
              <Col xl="4" style={{ paddingTop: '32px', textAlign: 'right' }}>
                <Button
                  className="btn-icon-clipboard"
                  type="button"
                  onClick={downloadReport}
                  style={{ textAlign: 'center' }}
                  title="Download Report"
                >
                  <i className="fas fa-download" style={{ fontSize: '14px' }}></i> Export
                </Button>
              </Col>
            </Row>
            <br />
            <Row>
              <Col xl="12">
                <Card style={{ padding: '0px 0px 0px 0px', marginBottom: "10px" }}>
                  <Table className="align-items-center table-flush custom-style" responsive size="sm" style={{ fontSize: '12px' }}>
                    <thead className="thead-light">
                      <tr>
                        <th>Sr.No.</th>
                        <th>Client Name</th>
                        <th>Sub Client</th>
                        <th>Type</th>
                        <th>Phase Name</th>
                        <th>Rejected From</th>
                        <th>Rejected By</th>
                        <th>Rejected To</th>
                        <th>Comment</th>
                        <th>Date</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportdata && reportdata.length ? (
                        reportdata.map((item, index) => (
                          <tr key={index} className={index % 2 == 0 ? 'purple-row' : 'orange-row'}>
                            <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                            <td className="whitespace">{item.company_name}</td>
                            <td className="whitespace">{item.sub_client}</td>
                            <td>{item.type}</td>
                            <td className="whitespace">{item.phase_name}</td>
                            <td className="whitespace">{item.rejected_from_phase}</td>
                            <td className="whitespace">{item.rejected_by}</td>
                            <td className="whitespace">{item.rejected_to}</td>
                            <td style={{maxWidth:'200px', wordBreak:'break-word'}}>{item.comment}</td>
                            <td className="whitespace">{formatDate(item.created_at)}</td>
                            <td>
                              {(item.rejected_to_user_id == user_info.id) ? (
                                <select
                                  className="form-control form-control-sm"
                                  value={item.status_id || 0}
                                  onChange={(e) => handleStatusChange(item.id, e.target.value)}
                                  style={{
                                    minWidth: '100px',
                                    fontSize: '12px',
                                    background: item.status_color_code ? item.status_color_code : 'none',
                                    color: item.status_color_code ? '#fff' : '#000'
                                  }}
                                >
                                  <option value="0" style={{background:'#fff', color:'#000'}}>Pending</option>
                                  {statusList && statusList.map((s) => (
                                    <option key={s.id} value={s.id} style={{background: s.color_code, color:'#fff'}}>{s.name}</option>
                                  ))}
                                </select>
                              ) : (
                                <span style={{
                                  backgroundColor: item.status_color_code || '#FEA732',
                                  color: '#fff',
                                  padding: '2px 8px',
                                  borderRadius: '4px',
                                  fontSize: '11px'
                                }}>
                                  {item.status_name || 'Pending'}
                                </span>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={11}>No records found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  <CardFooter className="py-4">
                    <Paginationcomponent
                      currentPage={currentPage}
                      totalItems={total_page}
                      rowsPerPage={rowsPerPage}
                      rowsPerPageOptions={rowsPerPageOptions}
                      handlePageClick={handlePageClick}
                      handlePreviousClick={handlePreviousClick}
                      handleNextClick={handleNextClick}
                      handleRowsPerPageChange={handleRowsPerPageChange}
                    />
                  </CardFooter>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </>
  );
};

export default InternalPhaseErrorReport;
